import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormTextProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFormTextProps>>
): IComponentSchema<IFormTextProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Form Text',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FormText,
    'x-component-props': {
      text: 'Text',
    },
    'x-component-props-config': {},
  };
};
